import request from '../utils/request'

// ==================== 广告中心 ====================

// 获取广告列表
export function getAdList(params) {
  return request({
    url: '/ad.ad_controller/list',
    method: 'get',
    params
  })
}

// 获取广告详情（含用户留言）
export function getAdDetail(id) {
  return request({
    url: '/ad.ad_controller/detail',
    method: 'get',
    params: { id }
  })
}

// 获取广告类型列表
export function getAdTypes() {
  return request({
    url: '/ad.ad_controller/types',
    method: 'get'
  })
}

// 发布广告
export function createAd(data) {
  return request({
    url: '/ad.ad_controller/create',
    method: 'post',
    data
  })
}

// 编辑广告
export function updateAd(data) {
  return request({
    url: '/ad.ad_controller/update',
    method: 'post',
    data
  })
}

// 广告上架/下架（1上架 0下架，下架后用户端不可见）
export function changeAdStatus(id, status) {
  return request({
    url: '/ad.ad_controller/changeStatus',
    method: 'post',
    data: { id, status }
  })
}

// ==================== 广告类型管理 ====================

// 获取广告类型列表（含停用的类型）
export function getAdTypeList(params) {
  return request({
    url: '/ad.type_controller/list',
    method: 'get',
    params
  })
}

// 获取广告类型详情
export function getAdTypeDetail(id) {
  return request({
    url: '/ad.type_controller/detail',
    method: 'get',
    params: { id }
  })
}

// 新增广告类型
export function createAdType(data) {
  return request({
    url: '/ad.type_controller/create',
    method: 'post',
    data
  })
}

// 编辑广告类型
export function updateAdType(data) {
  return request({
    url: '/ad.type_controller/update',
    method: 'post',
    data
  })
}

// 删除广告类型
export function deleteAdType(id) {
  return request({
    url: '/ad.type_controller/delete',
    method: 'post',
    data: { id }
  })
}

// ==================== 留言中心 ====================

// 获取留言列表
export function getAdMessageList(params) {
  return request({
    url: '/ad.message_controller/list',
    method: 'get',
    params
  })
}

// 获取留言详情
export function getAdMessageDetail(id) {
  return request({
    url: '/ad.message_controller/detail',
    method: 'get',
    params: { id }
  })
}

// 留言屏蔽/显示（1屏蔽 0恢复显示，屏蔽后用户端不可见）
export function changeAdMessageBlock(id, is_block) {
  return request({
    url: '/ad.message_controller/changeBlock',
    method: 'post',
    data: { id, is_block }
  })
}
